import { render, staticRenderFns } from "./ActivityFormDataTable.vue?vue&type=template&id=b6f690e6&"
import script from "./ActivityFormDataTable.vue?vue&type=script&lang=js&"
export * from "./ActivityFormDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports